import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'blank-router-page',
    templateUrl: './html/blank-router-page.component.html',
    styleUrls: ['./css/blank-router-page.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet],
})
export class BlankRouterPageComponent {
    constructor() {}
}
